/**
 * Окошко проекта — как на Latest works.
 */

function IconPlus() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 2V18" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M18 10H2" stroke="black" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}

function IconWatch() {
    return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="2"/>
            <path d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" stroke="currentColor" strokeWidth="2"/>
        </svg>
    );
}

function ProjectCard({ project, onAction }) {
    return (
        <article className="project-card">
            {project.placeholder ? (
                <div className="project-card__preview project-card__preview_empty" aria-hidden="true">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" strokeWidth="2" strokeLinecap="round">
                        <path d="M12 5v14M5 12h14"/>
                    </svg>
                </div>
            ) : (
                <img className="project-card__preview" src={project.image} alt={project.title} />
            )}
            <h3 className="project-card__title">{project.title}</h3>
            <button
                type="button"
                className="project-card__btn"
                onClick={() => onAction(project)}
            >
                {project.action === "order" ? <IconPlus /> : <IconWatch />}
                {project.button}
            </button>
        </article>
    );
}

export default ProjectCard;
// components/ProjectCard/ProjectCard.js
